import ExtractByTypename from 'graphql-client/ExtractByTypename';
import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

import {getBenchlingAppConfigurationQuery} from '../__generated/getBenchlingAppConfigurationQuery';

type Configuration = ExtractByTypename<
  getBenchlingAppConfigurationQuery['benchlingApp'],
  'BenchlingAppNode'
>['configuration'][number];

export const benchlingAppConfigurationBlockState = makeUseGlobalClientState<Array<Configuration>>([]);
